import type { SpecsAutoFormFieldMetadataMap } from "../autoFormMetadata";
import { ObservableModelNode } from "../observable";
import {
  cloneValue,
  expectObject,
  readObjectArray,
  splitKnown,
} from "../utils";
import { ProductVersionSizeRecommendationBracketModel } from "./ProductVersionSizeRecommendationBracketModel";

export class ProductVersionSizeRecommendationsModel extends ObservableModelNode {
  static autoFormFields: SpecsAutoFormFieldMetadataMap = {
    extra: { label: "Extra JSON", fieldType: "json", minRows: 4 },
  };

  sizeBrackets!: ProductVersionSizeRecommendationBracketModel[];
  extra!: Record<string, unknown>;

  constructor() {
    super();
    this.defineObservableValue("sizeBrackets", []);
    this.defineObservableValue("extra", {});
  }

  restore(snapshot: unknown) {
    const source = expectObject(snapshot, "product size recommendations");
    this.sizeBrackets = readObjectArray(source, "sizeBrackets").map((entry) =>
      new ProductVersionSizeRecommendationBracketModel().restore(entry)
    );
    this.extra = splitKnown(source, ["sizeBrackets"]);
    return this;
  }

  save() {
    return {
      ...cloneValue(this.extra),
      ...(this.sizeBrackets.length > 0
        ? { sizeBrackets: this.sizeBrackets.map((entry) => entry.save()) }
        : {}),
    };
  }
}
